import { Link } from "react-router-dom";

export const EMPRESA = {
  marca: "GSO Sites",
  razaoSocial: "Legis Marcas e Patentes LTDA",
  cnpj: "45.603.922/0001-21",
  email: "contato@samev.com.br",
};

/** Rodape do site: mesmo em toda pagina publica. */
export function Rodape() {
  return (
    <footer className="lp-rodape">
      <div className="lp-rodape-colunas">
        <div>
          <Link to="/" className="lp-marca">
            Samev
          </Link>
          <p className="lp-rodape-sobre">
            Sistema de Atendimento, Marketing e Vendas para empresas que vendem pelo WhatsApp.
          </p>
        </div>

        <div>
          <p className="lp-rotulo">Produto</p>
          <ul className="lp-rodape-lista">
            <li>
              <a href="/#recursos" className="lp-rodape-link">
                Recursos
              </a>
            </li>
            <li>
              <a href="/#para-quem" className="lp-rodape-link">
                Para quem
              </a>
            </li>
            <li>
              <Link to="/criar-conta" className="lp-rodape-link">
                Criar conta
              </Link>
            </li>
            <li>
              <Link to="/entrar" className="lp-rodape-link">
                Entrar
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="lp-rotulo">Samev</p>
          <ul className="lp-rodape-lista">
            <li>
              <a href="/blog" className="lp-rodape-link">
                Blog
              </a>
            </li>
            <li>
              <Link to="/afiliados" className="lp-rodape-link">
                Programa de afiliados
              </Link>
            </li>
            <li>
              <a href={`mailto:${EMPRESA.email}`} className="lp-rodape-link">
                {EMPRESA.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="lp-rotulo">Legal</p>
          <ul className="lp-rodape-lista">
            <li>
              <Link to="/termos" className="lp-rodape-link">
                Termos de Uso
              </Link>
            </li>
            <li>
              <Link to="/privacidade" className="lp-rodape-link">
                Privacidade e LGPD
              </Link>
            </li>
            <li>
              <Link to="/cookies" className="lp-rodape-link">
                Cookies
              </Link>
            </li>
            <li>
              <Link to="/termos-afiliados" className="lp-rodape-link">
                Termos de afiliados
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <p className="lp-rodape-base">
        © {new Date().getFullYear()} Samev, um produto {EMPRESA.marca}. {EMPRESA.razaoSocial}, CNPJ{" "}
        {EMPRESA.cnpj}.
      </p>
    </footer>
  );
}
